export const FETCH_ALLCLASSES_REQUEST = 'FETCH_ALLCLASSES_REQUEST'
export const FETCH_ALLCLASSES_SUCCESS = 'FETCH_ALLCLASSES_SUCCESS'
export const FETCH_ALLCLASSES_FALIURE = 'FETCH_ALLCLASSES_FALIURE'
